export const Rules = {
    STRING: 'string',
    INTEGER: 'integer',
    FLOAT: 'float',
    DATETIME: 'datetime',
    TEXT: 'text',
    URL: 'url',
    SET: 'SET',
    //INTEGER ACTIONS
    ADD: 'add',
    SUBTRACT: 'subtract',
    MULTIPLY: 'multiply',
    DIVIDE: 'divide',
    //STRING ACTIONS
    APPEND: 'append',
    PREPEND: 'prepend',
    REPLACE: 'replace',
    CONCAT: 'concat',

    //TARGET ATTRIBUTE
    VALUE_TYPE: 'value_type',
    TARGET_ATTRIBUTE: 'target_attribute',
    ACTION: 'action',
    VALUE_STATIC: 'value_static',
    VALUE_FIELD: 'value_field',
    VALUE_FIELD_ID: 'value_field_id',
    VALU_SEARCH: 'value_search',
    SET_VALUE_ACTION: 'set_value_action',
    SEARCH_STRING_TYPE: 'search_string_type',
    SEARCH_STATIC_VALUE: 'search_static_value',
    VALUE_LOOKUP_TABLE: 'value_lookup_table',
    LOOKUP_TABLE_ID: 'lookup_table_id',
    VALUE_LOOKUP_TABLE_COLUMN: 'value_lookup_table_column',
    LOOKUP_ATTRIBUTE_ID: 'lookup_attribute_id',
    SEARCH_FIELD: 'search_field',
    SEARCH_FIELD_ID: 'search_field_id',
    REPLACE_STRING_TYPE: 'replace_string_type',
    REPLACE_STATIC_VALUE: 'replace_static_value',
    REPLACE_FIELD: 'replace_field',
    REPLACE_FIELD_ID: 'replace_field_id',
    SEARCH_LOOKUP_TABLE: 'search_lookup_table',
    SEARCH_LOOKUP_TABLE_COLUMN: 'search_lookup_table_column',
    REPLACE_LOOKUP_TABLE: 'replace_lookup_table',
    REPALCE_LOOKUP_TABLE_COLUMN: 'replace_lookup_table_column',
    SET_SEARCH_STRING: 'set_search_string',
    SET_REPLACE_STRING: 'set_replace_string',

    OPERATOR_BASE_TYPE: 'operator_base_type',
    OPERATOR_BASE_STATIC_VALUE: 'operator_base_static_value',
    OPERATOR_BASE_FIELD: 'operator_base_field',
    OPERATOR_BASE_FIELD_ID: 'operator_base_field_id',

    OPERAND_TYPE: 'operator_operand_type',
    OPERAND_STATIC_VALUE: 'operator_operand_static_value',
    OPERAND_FIELD: 'operator_operand_field',
    OPERAND_FIELD_ID: 'operator_operand_field_id',

    //FOR URL CASE the base keyword is for the 2nd operand in url
    BASE_ACTION: 'base_action',
    BASE_TYPE: 'base_type',
    BASE_FIELD_ID: 'base_field_id',
    BASE_FIELD: 'base_field',
    BASE_LOOKUP_TABLE: 'base_lookup_table',
    BASE_LOOKUP_TABLE_COLUMN: 'base_lookup_table_column',
    BASE_STATIC: 'base_static',

    //Target Attribute new variables for making the expression from the clientSide
    OPERAND_ONE_ACTION: 'operand_one_action',
    OPERAND_ONE_VALUE_TYPE: 'operand_one_value_type',
    OPERAND_ONE_VALUE_STATIC: 'operand_one_value_static',
    OPERAND_ONE_VALUE_FIELD: 'operand_one_value_field',
    OPERAND_ONE_VALUE_FIELD_TITLE: 'operand_one_value_field_title',
    OPERAND_ONE_VALUE_FIELD_ID: 'operand_one_value_field_id',
    OPERAND_ONE_LOOKUP_TABLE: 'operand_one_lookup_table',
    OPERAND_ONE_LOOKUP_TABLE_COLUMN: 'operand_one_lookup_table_column',
    OPERAND_ONE_LOOKUP_TABLE_COLUMN_TITLE: 'operand_one_lookup_table_column_title',
    OPERAND_ONE_DATE: 'operand_one_date',

    OPERAND_TWO_ACTION: 'operand_two_action',
    OPERAND_TWO_VALUE_TYPE: 'operand_two_value_type',
    OPERAND_TWO_VALUE_STATIC: 'operand_two_value_static',
    OPERAND_TWO_VALUE_FIELD: 'operand_two_value_field',
    OPERAND_TWO_VALUE_FIELD_TITLE: 'operand_two_value_field_title',
    OPERAND_TWO_VALUE_FIELD_ID: 'operand_two_value_field_id',
    OPERAND_TWO_LOOKUP_TABLE: 'operand_two_lookup_table',
    OPERAND_TWO_LOOKUP_TABLE_COLUMN: 'operand_two_lookup_table_column',
    OPERAND_TWO_LOOKUP_TABLE_COLUMN_TITLE: 'operand_two_lookup_table_column_title',
    OPERAND_TWO_DATE: 'operand_two_date',


    //for the lookup filters
    LOOKUP_APPLY_NOT: 'apply_not',
    LOOKUP_PARENTHESIS_START: 'parenthesis_start',
    LOOKUP_OPERAND_ATTRIBUTE: 'operand_attribute',
    LOOKUP_OPERAND_ATTRIBUTE_ID: 'operand_attribute_id',
    LOOKUP_OPERAND_ATTRIBUTE_TITLE: 'up_operand_attribute_title',
    LOOKUP_OPERATOR_CATEGORY: 'operator_category',
    LOOKUP_OPERATOR: 'operator',
    LOOKUP_PARAM_TYPE: 'param_type',
    LOOKUP_PARAM_FIELD: 'param_field',
    LOOKUP_PARAM_FIELD_ID: 'param_field_id',
    LOOKUP_PARAM_FIELD_TITLE: 'param_field_title',
    LOOKUP_PARAM_STATIC_VALUE: 'param_static_value',
    LOOKUP_CREATABLE_VALUE: 'creatable_value',
    LOOKUP_PARENTHESIS_END: 'parenthesis_end',
    LOOKUP_LOGICAL_OPERATOR: 'logical_operator',
    LOOKUP_POPUP_HANDLER: 'popupHandler',
    LOOKUP_DATE: 'date',
    LOOKUP_STATIC_SINGLE_VALUE: 'static_single_value',
    LOOKUP_HAS_ERROR: 'has_error',

}


// WEBPACK FOOTER //
// ./src/constants/TransformationRulesConstants.js